import React, { useState } from "react";
import { Card, Tag, Image, Row, Col, Empty, Tooltip } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import "./ScrollableCourseCards.css";
import {
  VideoCameraOutlined,
  EnvironmentOutlined,
  LaptopOutlined,
  ForwardOutlined,
} from "@ant-design/icons";
import { formatDateWithSuffix } from "../../icons/ApplicationColor";
const ScrollableCourseCards = ({ courses, handleRowClick }) => {
  const [selectedIds, setSelectedIds] = useState([]);

  const toggleSelect = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  const getModeTag = (mode) => {
    const modeConfig = {
      Virtual: {
        // color: "blue",
        icon: <VideoCameraOutlined style={{ fontSize: "16px" }} />,
      },
      Onsite: {
        // color: "green",
        icon: <EnvironmentOutlined style={{ fontSize: "16px" }} />,
      },
      "E-Learning": {
        // color: "orange",
        icon: <LaptopOutlined style={{ fontSize: "16px" }} />,
      },
    };

    const { color, icon } = modeConfig[mode] || {
      color: "default",
      icon: "N/A",
    };

    return (
      <Tooltip title={`Mode : ${mode || "N/A"}`}>
        <Tag
          color={color}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "3px 6px",
            gap: "4px",
            // minWidth: "30px",
          }}
        >
          {icon}
        </Tag>
      </Tooltip>
    );
  };
  return (
    <div className="scrollable-course-cards">
      <div className="cards-grid-container">
        <Row gutter={[24, 24]}>
          {courses.map((course) => {
            const isSelected = selectedIds.includes(course.id);
            const spanValue =
              courses.length < 4 ? Math.floor(32 / courses.length) : 6;
            return (
              <Col
                xs={24}
                sm={spanValue}
                md={spanValue}
                lg={spanValue}
                xl={spanValue}
                key={course.id}
              >
                <Card
                  hoverable
                  className={`course-card ${isSelected ? "selected" : ""}`}
                  onClick={() => toggleSelect(course.id)}
                  bodyStyle={{ padding: 0 }}
                  cover={
                    <div className="image-wrapper">
                      {course?.image_url ? (
                        <Image
                          src={course.image_url}
                          alt={course.name}
                          preview={false}
                          height={150}
                          width="100%"
                          style={{
                            objectFit: "cover",
                            borderRadius: "8px 8px 0 0",
                          }}
                        />
                      ) : (
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                      )}

                      <div className="mode-tag-wrapper">
                        {getModeTag(course.mode)}
                      </div>

                      {isSelected && (
                        <div className="image-overlay">
                          <CheckCircleOutlined className="check-icon" />
                        </div>
                      )}
                    </div>
                  }
                >
                  <div className="card-content">
                    <h3 className="card-title flicker">{course.name}</h3>

                    <div className="info-section">
                      <div className="info-row">
                        <span className="info-item">
                          Category :{" "}
                          <span style={{ color: "black", fontWeight: "500" }}>
                            {course.category || "No Category"}
                          </span>
                        </span>
                        <span></span>
                      </div>

                      <div className="info-row">
                        <span className="info-item">
                          Language :{" "}
                          <span style={{ color: "black", fontWeight: "500" }}>
                            {course.language || "N/A"}
                          </span>
                        </span>
                        <span className="info-item">
                          Users :{" "}
                          <span style={{ color: "black", fontWeight: "500" }}>
                            {course.user_count || 0}
                          </span>
                        </span>
                      </div>

                      <div className="info-row">
                        <span className="info-item info-created">
                          Created :{" "}
                          <span style={{ color: "black", fontWeight: "500" }}>
                            {formatDateWithSuffix(course.created_at)}
                          </span>
                        </span>
                        <span
                          className="custom-extra"
                          onClick={(event) => {
                            event.stopPropagation();
                            handleRowClick(course.id);
                          }}
                        >
                          <span>See More</span>
                          <ForwardOutlined
                            className="see-more-icon"
                            style={{ marginLeft: "3px" }}
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </Card>
              </Col>
            );
          })}
        </Row>
      </div>
    </div>
  );
};

export default ScrollableCourseCards;
